import React from "react";

import { cn } from "src/shadcn/lib/utils";

interface TimezoneSelectProps {
  value?: string;
  onChange: (tz: string | undefined) => void;
  className?: string;
}

const TIMEZONE_OPTIONS = [
  { label: "Local", value: "" },
  { label: "UTC", value: "utc" },
] as const;

const TimezoneSelect: React.FC<TimezoneSelectProps> = ({
  value,
  onChange,
  className,
}) => (
  <div className={cn("flex items-center gap-1.5 text-sm", className)}>
    <span className="text-muted-foreground text-xs">Timezone</span>
    <select
      value={value ?? ""}
      onChange={e => onChange(e.target.value || undefined)}
      className={cn(
        "rounded-md border border-input bg-background px-2 py-0.5 text-xs",
        "focus:outline-none focus:ring-1 focus:ring-ring"
      )}
      aria-label="Select timezone"
    >
      {TIMEZONE_OPTIONS.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

TimezoneSelect.displayName = "TimezoneSelect";

export { TimezoneSelect };
